const utils = require('frontend-controller/lib/utils')

module.exports = {
	model: {
		parentAddressID: -1
		// resourceFilters: {
		// 	filters: {}
		// 	// offset: 0,
		// 	// limit: 999
		// }
	},

	events: {
		action: {
			type: 'click',
			action: function(event){
				var $target, rowID, fieldType;
				var self = event.data.component;
				if(($target = $(event.target).closest('button')).length > 0){
					event.preventDefault();
					event.stopImmediatePropagation();
					fieldType = $target.data('fieldType');
					rowID = $target.closest('.listRow').data('rowId');

					if(fieldType === 'showInsert'){
						self.showInsert();
					} else if(fieldType === 'showEdit' && rowID){
						self.showEdit(rowID);
					} else if(fieldType === 'move' && rowID){
						self.closest('templates_artCrm_address_recordController', function(recordController){
							recordController.backupScrollPosition();
							recordController.move((self.resourceData || {}).data || [], self.model.parentAddressID, rowID, $target.data('buttonMode') || '').then(function(){
								self.refresh(true, { restoreScrollPosition: true });
							});
						});
					} else if(fieldType === 'delete' && rowID){
						self.delete(rowID);
					}
				}
				// leave mailto and tel links be, but stop all other clicks from being handled by the parent form.
				else if(($target = $(event.target).closest('a[href!=""]')).length <= 0){
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			}
		}
	},

	methods: {
		dataDealer: function(){
			this.model.parentAddressID = (this.getResourceRegisterContent('relation') || {}).entityID;
		},

		getResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				resourceFilters = resourceFilters || {}
				if(!resourceFilters.filters) resourceFilters.filters = {}
				resourceFilters.filters.addressID = this.model.parentAddressID;
				resourceFilters.order = 'sort'
			}

			return resourceFilters;
		},

		sanitizeResources: function(){

		},

		showInsert: function(){
			var baseActionKey = 'showInsert_contact';

			if(this.actions[baseActionKey]){
				return this.performAndStoreAction(
					baseActionKey + '_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						entity: {},
					}),
					true
				);
			}
		},

		showEdit: function(addressID){
			var baseActionKey = 'showEdit_contact';

			if(this.actions[baseActionKey]){
				return this.performAndStoreAction(
					baseActionKey + '_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						entity: { resourceID: addressID },
					}),
					true
				);
			}
		},

		delete: function(addressID){
			var self = this;
			if(addressID){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.contact.title'),
						message:    storage.__('hint.delete.really.contact.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(self.prepareAction('delete_address', addressID)).then(function(){
							self.refresh();
							return utils.promise.resolve();
						});
					}

					return utils.promise.reject();
				});
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(options.restoreScrollPosition){
				this.closest('templates_artCrm_address_recordController', function(recordController){
					recordController.restoreScrollPosition();
				});
			}
		},

		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent && modalContentComponent.hasClass('templates_artCrm_address_propertiesForm')){
								var addNewAddressConnection = modalContentComponent.config.creationMode;

								const context = await modalContentComponent.submit()
								var sourceAddressID, targetAddressID;
								if(
									addNewAddressConnection &&
									(sourceAddressID = this.model.parentAddressID) &&
									(targetAddressID = ((context.response.data || {}).attributes || {}).addressID || 0)
								) {
									await this.performAction(this.prepareAction('insert_addressConnection', undefined, undefined, {
										source: {
											submit: {
												data: {
													data: {
														attributes: {
															sourceAddressID,
															targetAddressID
														}
													}
												}
											}
										}
									}))
								}

								await options.decisionComponent.hide()
								this.refresh()
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break;
					}
					break;

				default:
					break;
			}
		}
	}
};
